module.exports = __webpack_public_path__ + "static/img/banner.2566c734.gif";